export const isRequired = fieldName => `${fieldName} is verplicht`;

export const isRequiredSecondNationality = fieldName => `2\u1d49 nationaliteit is aangevinkt`;

export const isRequiredIBAN = fieldName => `${fieldName} is verplicht bij invullen IBAN`;

export const validDate = fieldName => `Vul een geldige datum in`

export const futureDate = fieldName => `${fieldName} kan niet in de toekomst liggen`

export const pastDate = fieldName => `Ongeldig jaartal`


export const minLength = length => {
  return (fieldName) => `${fieldName} moet ten minste ${length} tekens bevatten`;
};

export const maxLength = length => {
  return (fieldName) => `${fieldName} kan maximaal ${length} tekens bevatten`;
};

export const mustMatch = otherFieldName => {
  return (fieldName) => `${fieldName} is ongelijk aan ${otherFieldName.toLowerCase()}`;
};

export const mustNotMatch = otherFieldName => {
  return (fieldName) => `${fieldName} mag niet gelijk zijn aan ${otherFieldName.toLowerCase()}`;
};

export const number = fieldName => `${fieldName} mag alleen getallen bevatten (0-9)`

export const dutchZipCode = fieldName => `Vul een geldige postcode in.`

export const telephoneNumber = fieldname => `Vul een geldig telefoonnummer in`

export const email = fieldName => `Vul een geldig e-mail adres in`;

export const IBAN = fieldName => `Vul een geldig IBAN in (voorbeeld IBAN: NL97 BANK 0123 4567 89)`



// WEBPACK FOOTER //
// ./src/validation/errorMessages.jsx